

const baseUrl = 'http://localhost:5000';

export enum EditMode {
  Add,
  Update,
  Remove,
  List,
}

export enum MessageType {
  Success,
  Warning,
  Error,
  Info,
}


export class SystemMessage {
  public message: string;
  public color: string;

  constructor(message: string, color: string) {
    this.message = message;
    this.color = color;
  }
}

export class SuccessMessage extends SystemMessage {
  constructor(message: string) {
    super(message, 'success');
  }
}

export class WarningMessage extends SystemMessage {
  constructor(message: string) {
    super(message, 'warning');
  }
}

export class ErrorMessage extends SystemMessage {
  constructor(message: string) {
    super(message, 'error');
  }
}

export class InfoMessage extends SystemMessage {
  constructor(message: string) {
    super(message, 'info');
  }

}
